import React from 'react';
import S from "./Card.module.css";

const TextImgCard = ({ imgPath, title, content, wrapClass, titleClass, contentClass, imgClass, func }) => {

  return (
    <div className={S[wrapClass]} onClick={func}>
      <div>
        <img src={imgPath} className={S[imgClass]} alt='img' />
      </div>
      <div>
        {title && (<><span className={S[titleClass]}>{title}</span> <br /></>)}
        <div className={S[contentClass]}>{content}</div>
      </div>
    </div>
  );
}

export default TextImgCard;
